export * from './carousel';
export * from './categories';
export * from './insReportSrc';
export * from './ocrDumps';
export * from './ratings';
export * from './reportReview';
export * from './reportSolutionMaster';
export * from './roles';
export * from './scheduleBookings';
export * from './scheduleRequest';
export * from './settings';
export * from './users';
export * from './walkCall';
export * from './wcCategories';
export * from './wcSubCategories';
export * from './qualityReference';
export * from './personalityReference';
export * from './picStories';
export * from './stripeInvoices';
export * from './commonQuery';
export * from './companies';
export * from './solutionDescription';
export * from './testimonial';
export * from './kpi';



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/index.ts